var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 0.306625L0.72 5.70663C0.423345 6.10217 0.705573 6.66663 1.2 6.66663L9.3 6.66663C9.79443 6.66663 10.0767 6.10217 9.78 5.70663L5.73 0.306625C5.49 -0.0133743 5.01 -0.0133743 4.77 0.306625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSortUp);
export default __webpack_public_path__ + "static/media/ico-sort-up.7f71f0139444f81757a66873a8d79b14.svg";
export { ForwardRef as ReactComponent };